module.exports = __webpack_public_path__ + "static/media/finance-2.a48faa6c.webp";